var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-status-bar-component',{attrs:{"dots":true,"dots-object":_vm.dotsArray,"percentage":_vm.percentage,"rounded":true,"schema":"black"},on:{"dot-clicked":_vm.handleDotClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }